module.exports = __webpack_public_path__ + "static/wordmark-white-495379b599813351dc33f78f0ef85cd2.svg";